// import theme from './index'

export default {
  // welcomeTxt: `Welcome to %template%! Glad to serve you!
  // <br>Please enter a keyword to search~
  // <br><span style="color: #0087FF">Customer service support time:</span>
  // <br>Online support time: <span style="color: red">09:00 - 21:00;</span>
  // <br>400 customer service call time: <span style="color: red">9:00 - 12:00, 13:30 - 21:00.</span>`,
  welcomeTxt: `Welcome to %template%! Glad to serve you!
  <br>Please enter a keyword to search~
  <br><span style="color: #0087FF">Customer service support time:</span>
  <br>Online support time: <span style="color: red">09:00 - 21:00.</span>`,
  questionsLead: 'Below are the frequently asked questions',
  noWantContent: "Can't find what you need?",
  transferService: 'Transfer to customer service',
  helpful: 'helpful',
  useless: 'Useless',
  guessTips: 'I guess below is what you want to know, please click to inquire',
  noNeedContent: "Can't find what you need?",
  send: 'Send',
  searchNoEmptyTips: 'Please enter content',
  inputPlaceholder: 'Please enter a question',
  linkService: 'Connecting...',
  copy: 'Copy',
  withdraw: 'Withdraw',
  history: 'History',
  customerWithdrew: 'Customer service withdrew a message',
  youWithdrew: 'You withdrew a message',
  photoAlbum: 'Photo album',
  video: 'Video',
  file: 'File',
  serviceRating: 'Service rating',
  rantingLead: 'Please rate our service to help us improve. Are you satisfied with the answer of <span>%template%</span>?',
  satisfactory: 'Satisfactory',
  unsatisfactory: 'Unsatisfactory',
  satisfactoryOptionsTips: 'Options (multiple)',
  unSatisfactoryOptionsTips: 'Options (multiple)',
  goodAttitude: 'Good  attitude',
  respondPromptly: 'Respond promptly',
  solveTheProblem: 'Solve the problem',
  badAttitude: 'Bad attitude',
  noRespondInTime: "Didn't respond in time",
  notSolvingTheProblem: 'Not solving the problem',
  submit: 'Submit',
  noSubmit: 'Cancle',
  problemFeedback: 'Problem feedback',
  account: 'Account',
  accountPlaceholder: 'Please enter user id',
  phone: 'Phone',
  phonePlaceholder: 'Please enter your phone',
  errorPhoneTips: 'please enter a valid phone number',
  problemDescription: 'Problem description',
  problemDescriptionPlaceholder: 'Please provide class time and describe the specific problem in detail if you had a problem in class.',
  descriptionRequiredTips: 'Please enter a problem description',
  cancel: 'Cancel',
  sendPictures: 'Send pictures',
  submittedSuccessfully: 'Submitted successfully',
  copySuccessfully: 'Copy successfully',
  tips: 'Tips',
  leaveAMessage: 'Leave a message',
  noWorkTimeTips: 'Right now there is no customer service online\nPlease use the AI customer service to search the question you want to ask.',
  labelSelectTips: 'Please select at least one label!',
  noFreeService: 'Customer service is busy now.',
  goBack: 'Go back',
  useRobotTips: 'Please use the intelligent robot search to ask the question you want to ask.',
  multipleAccountTips: 'Your account is logged in other location.',
  loginSessionExpired: 'Login session expired',
  fileTypeTips: 'Please choose .doc, .docx, .pdf, ppt format files to send',
  fileSizeTips: 'File size cannot exceed 50M',
  cannotSendEmpty: 'Sending empty messages is not allowed',
  pleaseSelectVideo: 'Please select video to send',
  videoSizeTips: 'Video size cannot exceed 50M',
  Sending: 'Sending...',
  viewVideoPleaseClick: 'To view the video, please click',
  sendingfailedTryAgainTips: 'Sending failed, please try again',
  selectPictureToSend: 'Please select a picture to send',
  pictureSizeTips: 'Picture size cannot exceed 10M',
  yes: 'Yes',
  allowAccessFiles: 'Do you allow access to your files',
  failInSend: 'Fail in send',
  imageSendingFailed: 'Image sending failed',
  fileSendingFailed: 'File sending failed',
  VideoSendingFailed: 'Video sending failed',
  imageNotCompliantTips: 'The sent image is not compliant.',
  date: 'Date',
  chatDateRange: 'Chat date range',
  noRecords: 'No records',
  alreadyEvaluatedTips: 'You have already evaluated',
  linkFinished: 'Customer service connection has ended',
  inDepthThinking: 'In depth thinking...',
  deeplyPondered: 'Deeply pondered',
  askErrorTips: 'Oops! You can ask again.',
  noInServiceTimeTips: 'Currently not in customer service hours, you can',
  noOnlineServiceTips: 'There is currently no customer service online. Please use the intelligent robot to search and ask the questions you want to ask.',
  aiWaitTips: 'Ai is answering, please wait or cancel the previous question~',
  noFindContentTips: 'No relevant content found, you can ask again.',
  registeredPhone: 'Registered phone',
  // linkServiceHelpTips: 'Contact online CS for help by entering "manual" or "online customer service", or enter "work order" or "submit a work order" to submit your inquiry.'
  linkServiceHelpTips: 'For online customer service assistance, enter "manual" or "online customer service".  To submit your inquiry, enter "work order" or "submit a work order".',
  timeout_tips: 'Long inactivity; auto-exited human chat.',
  recallWaitTips: 'The message has not been sent yet, please wait ..',
  consultation_has_ended: 'The current conversation has ended'
}



// WEBPACK FOOTER //
// ./src/theme/enLang.js